import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import { cartAtom } from "core/cart";
import { price } from "core/shared";
import { URLS } from "framework/config/urls";
import { cartDrawerAtom } from "~/modules/shared/atoms/cart-drawer.atom";

export function CartDrawerFooter() {
  const cart = cartAtom.use("cart");

  if (!cart || cart.items.length === 0) return null;

  const finalPrice = cart.totals?.subtotal;

  return (
    <div className="flex flex-col gap-6 border-t bg-white px-10 py-6">
      {/* Total */}
      {finalPrice && (
        <div className="flex items-center justify-between">
          <span className="font-playfair text-2xl font-bold">
            {trans("cart.total")}
          </span>
          <span className="font-playfair text-2xl font-bold">
            {price(finalPrice)}
          </span>
        </div>
      )}

      {/* Buttons */}
      <div className="flex gap-4">
        <Link
          to={URLS.checkout.root}
          onClick={cartDrawerAtom.close}
          className="border-primary bg-primary-light font-playfair hover:bg-primary-200 flex-1 rounded-full border-2 px-6 py-3 text-center text-lg font-medium uppercase transition-colors"
        >
          {trans("checkout.title")}
        </Link>
        <Link
          to={URLS.cart}
          onClick={cartDrawerAtom.close}
          className="border-night font-playfair flex-1 rounded-full border-2 bg-white px-6 py-3 text-center text-lg font-medium uppercase transition-colors hover:bg-gray-100"
        >
          {trans("cart.goToCart")}
        </Link>
      </div>
    </div>
  );
}
